/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSplitEnabled } from '@bufferapp/features';
import { InstagramReminders } from './InstagramReminders';
import InstagramRemindersOld from './InstagramRemindersOld';

const InstagramRemindersSettings = (props) => {
  const { isEnabled: isRemindersEnabled } = useSplitEnabled('CORE-reminders');

  if (isRemindersEnabled) return <InstagramReminders {...props} />;
  return <InstagramRemindersOld {...props} />;
};

export default InstagramRemindersSettings;
